import type { Fetcher } from "react-query-kit";
import { createQuery } from "react-query-kit";

import type { IPickMutation } from "../../types";
import { getApi } from "../../apiPath";
import { axiosClient } from "../../clients";

import type { IUserPassword } from "./routeType";

const { key, getPath } = getApi("users.password.reset.post");

type IExtractedRouteType = IUserPassword["userSingleSendPasswordResetEmail"];

export type ISendPasswordResetEmail = IPickMutation<IExtractedRouteType>;

const sendPasswordResetEmail: Fetcher<
  ISendPasswordResetEmail["response"],
  ISendPasswordResetEmail["variables"]
> = (data) => {
  return axiosClient.post(getPath(), data);
};

export const useSendPasswordResetEmail = createQuery({
  queryKey: [key],
  fetcher: sendPasswordResetEmail,
});
